<template>
    <div v-if="loading && !division" class="d-flex align-center justify-center">
        <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
    </div>
    <div v-else-if="error">
        <v-alert type="error">
            <span v-if="error">{{ $translate('Error loading division') }}</span>
        </v-alert>
    </div>
    <div v-else-if="division">
        <v-sheet color="primary" class="pa-4">
            <h2 class="primarytext--text">Serie {{division.name}}</h2>
        </v-sheet>

        <v-expansion-panels multiple v-model="expandedPanels">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>{{$translate('Tables')}} {{division.name}}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="z-dense">
                    <v-tabs v-model="selectedTab" >
                        <v-tab>Översikt</v-tab>
                        <template v-if="toplistTypes">
                            <v-tab v-for="toplist_id in toplists" :key="toplist_id">{{toplistTypes.find(x => x.id == toplist_id).name}}</v-tab>
                        </template>
                    </v-tabs>

                    <v-tabs-items v-model="selectedTab" touchless>
                        <v-tab-item>
                            <TeamsportTable :divisionId="divisionId" />
                        </v-tab-item>

                        <template v-if="toplistTypes">
                            <v-tab-item v-for="toplist_id in toplists" :key="toplist_id">
                                <TeamsportToplist :divisionId="divisionId" :toplistId="toplist_id" />
                            </v-tab-item>
                        </template>
                    </v-tabs-items>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="showPlayoffTree">
                <v-expansion-panel-header>
                    <h2>{{$translate('Playoff tree')}}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="z-dense">
                    <TeamsportPlayoffTree :gameClassId="gc.id" />
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>{{$translate('Matches')}}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="z-dense">
                    <teamsport-matches :divisionId="divisionId" :isIndividual="gc.individual" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import TeamsportTable from './TeamsportTable.vue'
import TeamsportToplist from './TeamsportToplist.vue';
import TeamsportMatches from './TeamsportMatches.vue'
import TeamsportPlayoffTree from './TeamsportPlayoffTree.vue';
export default {
    name: 'zoezi-teamsport-division',

    zoezi: {
        title: 'Division page',
        icon: 'mdi-table-large',
        addon: 'TeamSports'
    },

    components: {
        TeamsportTable,
        TeamsportToplist,
        TeamsportMatches,
        TeamsportPlayoffTree
    },

    props: {
        divisionId: {
            title: 'Division ID',
            type: Number
        }
    },

    watch: {
        divisionId: {
            immediate: true,
            handler() {
                if (this.divisionId) {
                    this.loadDivision();
                    this.loadToplistTypes();
                }
            }
        }
    },

    data: () => ({
        loading: false,
        error: false,
        division: null,
        toplistTypes: null,
        gameclassSteps: null,
        expandedPanels: [0, 1, 2],
        selectedTab: null,
        unsubscribe: []
    }),

    computed: {
        gc() {
            return this.division.competitionstep.gameclass;
        },
        toplists() {
            return this.gc.toplists;
        },
        showPlayoffTree() {
            if (!(this.$store.state.settings?.modules.Cup && this.gc.steps.length > 1)) return false;
            // Hide the bracket for all-vs-all advancement. division/get only gives
            // step ids, so use the separately-fetched full steps (with rules).
            if (!this.gameclassSteps) return false;
            return !this.gameclassSteps.some(
                step => (step.transition_rules || []).some(rule => rule.type === 'group')
            );
        },
    },

    methods: {
        loadDivision() {
            this.loading = true;
            this.$api.get('/api/teamsport/division/get', {id: this.divisionId}).then(division => {
                if (division?.id) {
                    this.division = division;
                    // Fetch the full steps (with transition rules) to decide
                    // whether the playoff tree applies — division/get only gives step ids.
                    this.$api.get('/api/teamsport/gameclass/get_for_memberpage', {id: division.competitionstep.gameclass.id}).then(gc => {
                        this.gameclassSteps = gc?.steps || [];
                    }).catch(() => {
                        // Couldn't load the steps — keep the tree hidden rather than throw.
                        this.gameclassSteps = null;
                    });
                } else {
                    this.division = null;
                    this.error = true;
                }
                this.loading = false;
            }).catch(() => {
                this.division = null;
                this.error = true;
                this.loading = false;
            });
        },
        loadToplistTypes() {
            this.$api.get('/api/teamsport/toplist/get').then(toplistTypes => {
                this.toplistTypes = toplistTypes;
            });
        }
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    },
    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportdivision',  callback: (_, event) => {
            if (event.data.find(x => x.id == this.divisionId)) {
                this.loadDivision();
            }
        }}));
    }
}
</script>
